import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { RouteGuard } from "@/components/permissions/route-guard";

export const Route = createFileRoute("/_authenticated/services/_layout")({
  component: ServicesLayout,
});

function ServicesLayout() {
  const location = useLocation();
  const pathname = location.pathname;

  const isFormPage =
    pathname.includes("/services/new") || pathname.includes("/edit");

  return (
<RouteGuardPermissions
      permissions={[{ module: "services", actions: ["read"] }]}>
      
    <RouteGuard module="services">
      <div className="space-y-4">
        <Outlet />
      </div>
    </RouteGuard>
  
    </RouteGuardPermissions>
  );
}
